import deviceApi from './deviceApi'
import publicPlace from './publicPlace'
import scenicArea from './scenicArea'
import roleToScenicArea from './scenicPlace/roleToScenicArea'
import controlHistory from './scenicPlace/controlHistory'
import parkingAvailabilityRate from './scenicPlace/parkingAvailabilityRate'
import videoCamera from './device/videoCamera'
import handSanitizer from './device/handSanitizer'
import peculiarSmell from './device/peculiarSmell'
import deviceError from './device/deviceError'
import iotEvent from './device/iotEvent'
import iotData from './iotData'
import humanSensor from './humanSensor'

import passengerEstimateSetting from './setting/passengerEstimateSetting'
import holidaySetting from './setting/holidaySetting'
import disasterSettingDBModal from './setting/disasterSetting'
import activity from './Activity/activity'
export default {
	state: {
	},
	modules: {
		deviceApi,
		publicPlace,
		scenicArea,
		roleToScenicArea,
		controlHistory,
		parkingAvailabilityRate,
		videoCamera,
		handSanitizer,
		peculiarSmell,
		deviceError,
		iotEvent,
		passengerEstimateSetting,
		holidaySetting,
		disasterSettingDBModal,
		activity,
		iotData,
		humanSensor
	},
}